export const MOTION_VAR_INITIAL = "initial";
export const MOTION_VAR_ANIMATE = "animate";
export const MOTION_VAR_EXIT = "exit";

export const PAGE_ANIMATE_MODE = "wait";

export const PAGE_ANIMATE_VARIANTS = {
  variants: {
    initial: { opacity: 0, x: 10 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -10 },
  },
  transition: { duration: 0.3 },
};

export const LIST_ANIMATE_VARIANTS = {
  variants: {
    initial: { opacity: 0, y: -10 },
    animate: { opacity: 1, y: 0 },
  },
  transition: { duration: 0.5 },
};
